const columns = (renderCell, renderLocationField, renderAttachmentField, renderProgressField) => {
  return [
    {
      field: 'timestamp',
      headerName: 'Timestamp',
      width: 250,
      hide: false,
      renderCell,
      headerAlign: 'center'
    },
    {
      field: 'userEmail',
      headerName: 'Email',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'issue',
      headerName: 'Issue',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 400,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'location',
      headerName: 'Location',
      width: 300,
      renderCell: renderLocationField,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'attachments',
      headerName: 'Attachments',
      width: 100,
      renderCell: renderAttachmentField,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'progress',
      headerName: 'Progress',
      width: 200,
      renderCell: renderProgressField,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};

export default columns;
